import type { SubNavPropsWithItems } from "@douyinfe/semi-ui/lib/es/navigation";

export interface NavItem extends SubNavPropsWithItems {
  activeIcon?: React.ReactNode;
  InActiveIcon?: React.ReactNode;
}

export const MENUS: NavItem[] = [
  { itemKey: "about", text: "About" },
  { itemKey: "docking", text: "Docking" },
  { itemKey: "design", text: "Design" },
];
